
export enum CampaignSettingsStatus {
    Active = 1,
    Removed = 2
}